/** The `field` every period column (main or shadow) is defined with. */
export const mainMonthColumnId = "period";
/** When `pages.main_column_type` is null we treat the main column as a period column. */
export const DEFAULT_MAIN_COLUMN_TYPE = "period";
export const COLUMN_TYPE_OPTIONS = [
    { id: "period", label: "Period", headerLabel: "Period", columnType: "month", mainColumnType: "period" },
    {
        id: "month-code",
        label: "Month code",
        headerLabel: "Code",
        columnType: "period-code",
        mainColumnType: "month_code",
    },
    {
        id: "time-spread",
        label: "Time spread",
        headerLabel: "Spread",
        columnType: "month-timespread",
        mainColumnType: "time_spread",
    },
    { id: "cfd-week", label: "CFD week", headerLabel: "CFD Week", columnType: "week", mainColumnType: "cfd_week" },
    {
        id: "cycles",
        label: "Cycles calc",
        headerLabel: "Cycles Calc",
        columnType: "cycles",
        mainColumnType: "cycles_calc",
    },
    {
        id: "cycles-periods",
        label: "Cycles periods",
        headerLabel: "Cycles Periods",
        columnType: "cycles-periods",
        mainColumnType: "cycles_periods",
    },
    {
        id: "osn-half",
        label: "OSN Half",
        headerLabel: "OSN Half",
        columnType: "osn-half",
        mainColumnType: "osn_half",
    },
    { id: "count", label: "Count", headerLabel: "Count", columnType: "count", mainColumnType: "count" },
    { id: "blank", label: "Blank", headerLabel: "", columnType: "blank", mainColumnType: "blank" },
];
/** Coerce a raw `pages.main_column_type` value (which may be null) to a known type. */
export function normalizeMainColumnType(value) {
    return (COLUMN_TYPE_OPTIONS.find((option) => option.mainColumnType === value)?.mainColumnType ?? DEFAULT_MAIN_COLUMN_TYPE);
}
/** The header label displayed for the main month column at a given type. */
export function mainColumnTypeHeaderLabel(value) {
    return COLUMN_TYPE_OPTIONS.find((option) => option.mainColumnType === value)?.headerLabel ?? "Period";
}
const MAIN_COLUMN_TYPE_MIN_WIDTHS = {
    time_spread: 110,
    cfd_week: 90,
    cycles_calc: 120,
    cycles_periods: 110,
    osn_half: 90,
};
export function mainColumnTypeMinWidth(value) {
    return MAIN_COLUMN_TYPE_MIN_WIDTHS[value] ?? 0;
}
//# sourceMappingURL=column-types.js.map